<template>
  <ReturnGoodsEditingSection
          :RG="RG"
          :createData="createData"
          :optionsStorage="optionsStorage"
          @save="save"
  />
</template>

<script>
  import {ReturnGoods} from "../models/ReturnGoods";
  import ReturnGoodsEditingSection from "./ReturnGoodsEditingSection/ReturnGoodsEditingSection";
  import {returnGoodsMixin} from "@/mixins/returnGoodsMixins/returnGoodsMixin";

  export default {
    name: "ReturnGoodsCreation",

    components:{
      ReturnGoodsEditingSection,
    },

    mixins: [returnGoodsMixin],

    data() {
      return {
        RG: new ReturnGoods(),
        transactionUser: {},
        createData: null,
        optionsStorage: [],
      }
    },

    mounted() {
      this.initReturnGoodsEdit()
      this.getWarehouseStorages()
    },

    methods: {


      initReturnGoodsEdit() {

        this.RG.data.Order.setId(this.$route.params.id)

        this.$store.dispatch('getReturnGoods', this.RG.data.Order.getId()).then((response) => {
          let item = this.getRespData(response)
          this.RG.setItem(item, this)

          let files = item?.file_entities

          this.downloadFileFromArray(files).then((documents) => {
            let filesObj = this.RG.data.Files
            filesObj.setDownloadFiles(documents)
          })

        }).catch(error => this.createErrorLog(error))
      },

      async getWarehouseStorages() {
        return this.$store.dispatch('fetchWarehouseStorage').then((response) => {
          this.optionsStorage = this.getRespPaginateData(response)
        })
      },

    }

  }
</script>

<style scoped>

</style>
